<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('courses.attendance_list') + ': ' + (_.has(course, 'id') ? course.name : '')"></page-header-title>

      <v-spacer></v-spacer>

      <action-button type="back" @click="$router.go(-1)" />
      <action-button type="save" @click="save" />
    </v-app-bar>

    <v-form ref="form">
      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex xs12>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">{{ $t("participants.name") }}, {{ $t("participants.birthday") }}</th>
                        <th class="text-left">{{ $t("participants.mobile") }}</th>
                        <template v-if="_.has(course, 'id') && course.course_dates">
                          <th class="text-center" v-for="(cdate, idx) in course.course_dates" :key="idx">
                            <span class="d-block text-center">{{ $dateFormatGetter(cdate.date) }}</span>
                            <v-checkbox
                              class="chk-num-of-days d-inline-block"
                              @change="checkAll(cdate.date, $event)"
                            ></v-checkbox>
                          </th>
                        </template>

                        <th class="text-left"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in attendees" :key="item.name">
                        <td class="pa-5">
                          <v-avatar size="35" color="indigo" class="float-left mr-3">
                            <v-img :src="item.participant_image ? item.participant_image : require('@/assets/img/no-image.jpg')"> </v-img>
                          </v-avatar>

                          <span>
                            <a @click="showForm(item.participant_id, 'participant')">{{ item.participant_name }}</a
                            ><br />
                            {{ item.participant.date_of_birth ? moment(item.participant.date_of_birth).format(DATE_FORMAT) : "" }}
                          </span>
                        </td>
                        <td>{{ item.participant.mobile }}</td>
                        <template v-if="_.has(course, 'id') && course.number_of_days">
                          <td v-for="(cdate, idx) in course.course_dates" :key="idx" class="text-center">
                            <v-checkbox
                              v-model="item.met_up_days.find(i => i.date == cdate.date).value"
                              class="chk-num-of-days d-inline-block"
                            ></v-checkbox>
                          </td>
                        </template>
                        <td>
                          <v-textarea v-model="item.comment" rows="2" auto-grow :label="$t('enrolments.comment')"></v-textarea>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>

    <v-dialog v-model="showDialogForm" persistent max-width="90%">
      <div class="form-modal pa-4">
        <component
          :is="currentLoadedForm.form"
          :id="currentLoadedForm.id"
          :modal="true"
          :from_module="currentFromModule"
          @return_modal_form="return_modal_form"
          @return_modal_cancel_form="return_modal_cancel_form"
        ></component>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "courseAttendance",

  props: ["id"],

  components: {
    "participant-form": () => import("../../participants/components/Form")
  },

  data() {
    return {
      course: {},
      attendees: [],
      dates: [],

      currentFormId: null,
      currentForm: null,
      currentFromModule: "attendance",
      showDialogForm: false
    }
  },

  created() {
    axios
      .get(this.API_URL + "course/" + this.id + "?resourcetype=course-attendance")
      .then((res) => {
        this.course = res.data.data

        // Get dates
        let start = this.moment(this.course.start_date, this.MYSQL_DATE_FORMAT)
        let end = this.moment(this.course.end_date, this.MYSQL_DATE_FORMAT)
        let number_of_days = end.diff(start, "days")

        for (var m = start; m.diff(end, "days") <= 0; m.add(1, "days")) {
          var day = m.day()
          var isWeekend = day === 6 || day === 0 // 6 = Saturday, 0 = Sunday

          if (this.course.exclude_weekends) {
            if (!isWeekend) {
              this.dates.push(m.format("DD.MM"))
            }
          } else {
            this.dates.push(m.format("DD.MM"))
          }
        }

        this.loadAttendees()
      })
      .catch((err) => console.log(err))
  },

  computed: {
    currentLoadedForm: function () {
      let form,
        id = null

      if (this.currentForm) {
        this.showDialogForm = true

        id = this.currentFormId
        form = this.currentForm
      }

      return {
        id: id,
        form: form
      }
    }
  },

  methods: {
    loadAttendees() {
      axios.get(this.API_URL + "attendees?resourcetype=attendee-attendance&show_all=true&query_course_id=" + this.id).then((res) => {
        this.attendees = res.data.data
      })
    },
    checkAll(date, event) {
      this.attendees.forEach((item, i) => {
        item.met_up_days.find(i => i.date == date).value = event
      })
    },

    save() {
      let vm = this
      let data = []

      this.attendees.forEach((item, i) => {
        let obj = {}

        obj.id = item.id
        obj.met_up_days = item.met_up_days
        obj.comment = item.comment

        data.push(obj)
      })

      axios
        .put(this.API_URL + "course/attendance", {
          id: this.course.id,
          data: data
        })
        .then((res) => {
          vm.$awn.success(vm.$t("global.update_success"))
        })
        .catch((err) => console.log(err))
    },

    showForm(id, type) {
      this.currentFormId = id
      this.currentForm = type + "-form"
    },
    return_modal_form(data) {
      this.return_modal_cancel_form()
      this.loadAttendees()
    },
    return_modal_cancel_form() {
      this.currentFormId = null
      this.currentForm = null
      this.showDialogForm = false
    }
  }
}
</script>

<style scoped></style>
